import { render, staticRenderFns } from "./LockRatioOffIcon.vue?vue&type=template&id=0f37bedc&"
import script from "./LockRatioOffIcon.vue?vue&type=script&lang=js&"
export * from "./LockRatioOffIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports